
import "/app/src/components/BootstrapStateView/index.module.less?modules";
export default {"readonly": `readonly-oGh054t5`,"description": `description-esvMAkay`,"title": `title-a3GlTszx`,"error": `error-s2DXSltV`,"card": `card-fVjQB-V9`,"warning": `warning-DCUttjhh`,"wrapper": `wrapper-JwmigDZR`,"icon": `icon-sKuH0--i`,"empty": `empty-j5SUiX2P`}
